export const gitVersion = '1.0.2-38-g6c9e6c1';
